import React from 'react';
import { Lists, HeaderSwiper } from '@/components/mixins'
import '../../common/common.scss'
import './Development.scss'
class Development extends React.PureComponent {
  constructor() {
    super()
    this.state = {
      headerDataLists: [
        { imgPath: require("img/EcosphereDetails/Developmentbanner.png"), imgHDPath: `${require("img/EcosphereDetails/Developmentbanner.png")} 1x,${require("img/EcosphereDetails/Developmentbanner@2x.png")} 2x,${require("img/EcosphereDetails/Developmentbanner@3x.png")} 3x`, attachURL: "/" }
      ],
      dataLists01: [
        {
          title: '互联网产品',
          data: '提供更便捷、更轻量的管理平台、工具软件、APP及平台类的互联网产品，帮助使用者打破障碍，随时随地高效工作。',
        },
        {
          title: '系统定制化开发与集成',
          data: '专业的软件开发，系统平台的搭建；根据客户的需求，对软件进行独立自主定制开发与集成。',
        },
        {
          title: '信息化咨询与审计',
          data: '帮助企业建立完备的信息化规划体系，提炼信息化规划的焦点问题；通过对信息化系统的审计，评估客户信息系统的真实性、完整性、安全性。',
        }
      ],
      dataLists02: [
        {
          title: '咨询企业云平台',
          data: '咨询企业云平台是主要服务于中小型咨询企业的一款轻量级、模块化的咨询企业管理系统。基于企业管理思路，结合先进的企业管理理念及互联网思维，建立以“项目”为主线，以高效标准化的业务流程为导向的工作规范。根据咨询企业不同的自身情况，量身匹配业务需求，让企业“像搭积木一样，自定专属的企业管理系统”，采用“云”处理方式，帮助企业降低管理成本，提高工作效率。',
          imgPath: require("img/EcosphereDetails/Developmenticon01.png"), imgHDPath: `${require("img/EcosphereDetails/Developmenticon01.png")} 1x,${require("img/EcosphereDetails/Developmenticon01@2x.png")} 2x,${require("img/EcosphereDetails/Developmenticon01@3x.png")} 3x`
        },
        {
          title: '成本云平台',
          data: '成本云为企业客户提供高效、严格、标准的成本管控服务，实现从项目立项、制定目标成本、合约规划、监测动态成本、招标管理、合同管理到核对结算成本等环节的全过程一体化成本管控。<br/>平台地址:<a class="link" href="https://www.icostcloud.com/">https://www.icostcloud.com/</a>',
          imgPath: require("img/EcosphereDetails/Developmenticon02.png"), imgHDPath: `${require("img/EcosphereDetails/Developmenticon02.png")} 1x,${require("img/EcosphereDetails/Developmenticon02@2x.png")} 2x,${require("img/EcosphereDetails/Developmenticon02@3x.png")} 3x`
        },
        {
          title: '造价咨询企业集成工作平台',
          data: '适用于造价咨询企业内部的管理系统，功能主要包含：人力资源管理、财务管理、客户管理、项目管理、合同管理、报告管理、工时管理、考核管理等核心管理模块，全面覆盖企业管理的各个阶段。系统采用“云”处理方式，将重要运营数据全部实现在线存储和维护，保障数据的安全性和可操作性。',
          imgPath: require("img/EcosphereDetails/Developmenticon03.png"), imgHDPath: `${require("img/EcosphereDetails/Developmenticon03.png")} 1x,${require("img/EcosphereDetails/Developmenticon03@2x.png")} 2x,${require("img/EcosphereDetails/Developmenticon03@3x.png")} 3x`
        },
        {
          title: '会计师事务所综合管理平台',
          data: '主要功能：人力资源管理、行政办公管理、财务管理、IT服务管理、项目管理、知识管理等核心管理模块，全面覆盖事务所经营管理的各个阶段，规范了事务所的内部管理流程，落地内部管理标准，提升内部管理效率的同时，最大程度上的保证了事务所内部控制的质量。',
          imgPath: require("img/EcosphereDetails/Developmenticon04.png"), imgHDPath: `${require("img/EcosphereDetails/Developmenticon04.png")} 1x,${require("img/EcosphereDetails/Developmenticon04@2x.png")} 2x,${require("img/EcosphereDetails/Developmenticon04@3x.png")} 3x`
        },
        {
          title: '企业审计管理系统',
          data: '企业风控管理系统通过建立风险地图、内控矩阵，进行企业风险评估，内控矩阵评价，以及评价问题的整改，提升各个业务线的管理能力。系统提供强大的图表展示功能，便于企业管理层直观了解企业管理问题，进行辅助决策。',
          // <br/><a class="link" href="http://www.tztech.net/%E4%BC%81%E4%B8%9A%E5%AE%A1%E8%AE%A1%E7%AE%A1%E7%90%86%E7%B3%BB%E7%BB%9F">了解更多...</a>
          imgPath: require("img/EcosphereDetails/Developmenticon05.png"), imgHDPath: `${require("img/EcosphereDetails/Developmenticon05.png")} 1x,${require("img/EcosphereDetails/Developmenticon05@2x.png")} 2x,${require("img/EcosphereDetails/Developmenticon05@3x.png")} 3x`
        },
        {
          title: '行业协会会员管理系统',
          data: '满足各行业协会和社会团体对本协会会员进行综合管理的需要，实现了会员注册、会员审核、会员会费的缴纳、会员查询、会员分类统计、会员线下培训的安排，入会考试的安排等功能，实现了会员管理的信息化，提高了工作效率，规范了业务流程，便于协会进行数据分析统计及开展相应的会员服务。',
          imgPath: require("img/EcosphereDetails/Developmenticon06.png"), imgHDPath: `${require("img/EcosphereDetails/Developmenticon06.png")} 1x,${require("img/EcosphereDetails/Developmenticon06@2x.png")} 2x,${require("img/EcosphereDetails/Developmenticon06@3x.png")} 3x`
        },
        {
          title: '青音会议系统',
          data: '青音会议系统是一款轻量级、全功能的远程视频会议系统。能够全方位满足用户的远程会议、视频会议、方案分享、方案演讲及文档协作等远程工作需求。<br />除此之外，它更突出的优势是：无需下载任何插件、APP或第三方应用，作为参会者，无需登录，一键点开链接（电脑、手机、Pad均可），即可随时随地快速入会。基于低延迟高质量的音视频服务，保障视频及语音流畅无延迟，还原现场，实现如面对面般顺畅自如的沟通体验。<br/>系统地址:<a class="link" href="https://greemeeting.com/">https://www.greemeeting.com</a>',
          imgPath: require("img/EcosphereDetails/Developmenticon07.png"), imgHDPath: `${require("img/EcosphereDetails/Developmenticon07.png")} 1x,${require("img/EcosphereDetails/Developmenticon07@2x.png")} 2x,${require("img/EcosphereDetails/Developmenticon07@3x.png")} 3x`
        },
      ],
    }
  }
  render() {
    return (
      <main className="Development-container">
        <HeaderSwiper headerDataLists={this.state.headerDataLists}></HeaderSwiper>
        <div className="Development">
          <h5 className='product-title'>服务内容</h5>
          <Lists dataLists={this.state.dataLists01}></Lists>
          <h5 className='product-title'>特色产品</h5>
          <Lists dataLists={this.state.dataLists02}></Lists>
          {/* <div className="more-produce-link">
            <a href="http://www.tztech.net/%E9%80%A0%E4%BB%B7%E5%92%A8%E8%AF%A2%E4%BC%81%E4%B8%9A%E4%BA%91%E5%B9%B3%E5%8F%B0" className="more-produce">更多产品</a>
          </div> */}
        </div>
      </main>
    )
  }
}
export default Development
